import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import '@/fontawesome.ts'
import { handleCrossOriginScriptError, reportError } from '@/services/errorReporter'
import App from '@/App.tsx'

window.addEventListener('error', (event) => {
  if (handleCrossOriginScriptError(event)) return;
  const err = event.error instanceof Error ? event.error : undefined;
  const message = event.message !== '' ? event.message : 'Uncaught error';
  reportError('Err', 'FRONTEND_UNCAUGHT', message, err, {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const err = reason instanceof Error ? reason : undefined;
  const message = err !== undefined ? err.message : `Unhandled rejection: ${String(reason)}`;
  reportError('Err', 'FRONTEND_PROMISE', message, err, {
    reason: err === undefined ? String(reason) : undefined,
  });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
